module.exports = __webpack_public_path__ + "static/media/k_adamawe_k_nife.51c15689.pdf";